/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AccountFilters {
    getFixupPrototypeFunction() { return AccountFilters.fixupPrototype; }

    static newInstance(model: Partial<AccountFilters>): AccountFilters {
        let obj = Object.assign(new AccountFilters(), model);
        AccountFilters.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AccountFilters>): AccountFilters {
        if (!model) return null;
        return AccountFilters.newInstance(<AccountFilters> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AccountFilters) {
        if (!obj) return;

        models.AccountFilters.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AccountFilters): boolean {
        Object.setPrototypeOf(obj, AccountFilters.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Tenants to include (all if missing)
     */
    tenants: Array<string>;

    /**
     * Cloud Providers to include (all if missing)
     */
    clouds: Array<models.CloudServiceName>;

    /**
     * Cloud Accounts to include (all if missing)
     */
    cloud_accounts: Array<string>;

    /**
     * Regions to include (all if missing)
     */
    regions: Array<string>;

    /**
     * Resources filter to filter (all if missing)
     */
    resource_filter: Array<string>;

    /**
     * Product Categories to include (all if missing)
     */
    product_categories: Array<string>;

    /**
     * Inventory Category of the resources to filter (all if missing)
     */
    category: string;

    /**
     * Type of Resources to include (all if missing)
     */
    resource_type: Array<string>;

}
